import React from 'react';

function Contact() {
    return (
        <div className="container">
            <h1 style={{ textAlign: 'center', color: '#5F7161' }}>📞 Book Your Appointment 📞</h1>

            <div className="contact-container" style={{ justifyContent: 'center' }}>

                <div className="contact-info" style={{ textAlign: 'center', maxWidth: '450px', margin: '0 auto' }}>

                    {/* Added margin-bottom to create space after the title */}
                    <h3 style={{ marginBottom: '20px' }}>Ready to Relax?</h3>
                    <p style={{ marginBottom: '30px' }}>
                        The quickest way to book and confirm your personalized massage session is by phone.
                        We look forward to speaking with you!
                    </p>

                    {/* Increased vertical padding within the card and added substantial bottom margin */}
                    <div style={{
                        margin: '30px 0 50px 0', /* Added 50px bottom margin */
                        padding: '30px', /* Increased internal padding */
                        borderRadius: '8px'
                    }}>

                        <h2>Call Us to Book Now:</h2>

                        <a
                            href="tel:+19097673286"
                            className="btn"
                            style={{
                                fontSize: '1.5rem',
                                padding: '15px 30px',
                                width: 'auto',
                                marginTop: '15px' /* Added space above the button */
                            }}
                        >
                            (909) 767-3286
                        </a>
                    </div>

                    {/* Added margin-bottom to create space after the header */}
                    <h3 style={{ marginTop: '40px', marginBottom: '20px' }}>Our Location & Hours</h3>
                    <p>
                        Visit Us:<br />
                        9591 W Foothill Blvd<br />
                        Rancho Cucamonga, CA 91730
                    </p>
                    <p style={{ marginTop: '20px' }}>
                        Hours:<br />
                        Mon - Sun: 9:00 AM - 10:00 PM
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Contact;